<template>
<div class="chapter">
<div class="inner_page">
<div class="wordsection">
<p class="msonormal"><img alt="" class="textblock1" src="Images/title.gif" width="100%"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// final_split_000.vue?1d3b0126